export const sysSetting = {
  tableCol: {
    no: { en: 'No.', ko: '번호', fr: '' },
    category: { en: 'Category', ko: '카테고리', fr: '' },
    keyName: { en: 'Key Name', ko: '키 명', fr: '' },
    keyValue: { en: 'key Value', ko: '키 값', fr: '' },
  },
  info: {
    no: { en: 'No.', ko: '번호', fr: '' },
    category: { en: 'Category', ko: '카테고리', fr: '' },
    keyName: { en: 'Key Name', ko: '키 명', fr: '' },
    keyValue: { en: 'key Value', ko: '키 값', fr: '' },
  },
  placeholder: {
    keyName: { en: 'Search by Key name', ko: '키 이름을 입력하세요.' },
  },
};
